import React from "react";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import { PLEASE_WAIT, LOADING_IFS_DOCUMENT } from "../../../../../redux/constants/messageTypes";

export function WorkingDocumentDetailsDialogProgress({
  isDetailsNoData,
  isDetailsError,
  isDetailsLoading,
  theme,
}) {
  if (isDetailsNoData) {
    return null;
  }
  if (isDetailsError) {
    return null;
  }
  if (isDetailsLoading) {
    return (
      <>
        <Typography
          variant="body2"
          sx={{
            fontFamily: theme.fonts.regular,
            fontSize: `${theme.fontSizes?.normal ?? 12}px`,
            marginBottom: "8px",
            color: theme.colors.fontColor,
            textAlign: "center",
          }}
        >
          {LOADING_IFS_DOCUMENT}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            fontFamily: theme.fonts.regular,
            fontSize: `${theme.fontSizes?.normal ?? 12}px`,
            marginBottom: "24px",
            color: theme.colors.fontColor,
            textAlign: "center",
          }}
        >
          {PLEASE_WAIT}
        </Typography>
        <CircularProgress
          size={80}
          thickness={4}
          sx={{ color: "#249F5D" }}
        />
      </>
    );
  }
  return null;
}
